import React, { useState, useEffect } from 'react';
import { editExpenseCategory } from '../utils/api';
import './EditExpenseCategoryModal.css';

const EditExpenseCategoryModal = ({ show, onClose, category, onCategoryUpdated }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (category) {
            setName(category.name || '');
            setDescription(category.description || '');
        }
    }, [category]);

    const handleUpdate = () => {
        if (!name) {
            setError('Category name is required.');
            return;
        }

        const categoryData = { name, description };

        editExpenseCategory(category.id, categoryData)
            .then(() => {
                setError('');
                onCategoryUpdated();
                onClose();
            })
            .catch(error => {
                console.error("Error updating expense category:", error);
                setError('Failed to update category.');
            });
    };

    if (!show) {
        return null;
    }

    return (
        <div className="edit-expense-category-modal-overlay">
            <div className="modal-content">
                <h2>Edit Expense Category</h2>
                {error && <p className="error-message">{error}</p>}
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Category Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <div className='actions-centered'>
                    <button onClick={onClose} className='cancel-button text-button'>Cancel</button>
                    <button onClick={handleUpdate} className='submit-button text-button'>Update</button>
                </div>
            </div>
        </div>
    );
};

export default EditExpenseCategoryModal;